import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

type ContentResultProps = {
  success?: boolean;
};

type ContentTitleProps = {
  align: string;
};

type ShowTourProps = {
  showTour: false;
};

export const ContentWrap = styled.div<ShowTourProps>`
  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
      background-color: #ffff;
      padding: 4px;
      border-radius: 8px;
    `}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 35px;
  padding: 25px 35px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  min-height: calc(100vh - 80px - calc(35px * 2));

  @media (max-width: 768px) {
    margin: 16px;
    padding: 24px 19px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 17px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
`;

export const HeaderInfos = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 37px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 33px;
  }
`;

export const HeaderSubtitle = styled.h2`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 16px;
  line-height: 24px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const Body = styled.div`
  display: flex;
  overflow: auto;
  height: 100%;
  width: 100%;
  margin-top: 34px;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ContentLeft = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid black;
  padding: 30px 25px;

  @media (max-width: 768px) {
    border: 0;
    width: 100%;
    padding: 0;
  }
`;

export const ContentRight = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 25px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`;

export const ContentTitle = styled.h2<ContentTitleProps>`
  font-weight: 600;
  font-size: 18px;
  line-height: 1;
  margin: 0;
  color: #818181;
  text-align: ${(props) => props.align};
`;

export const ContentInfos = styled.div`
  display: flex;
  align-items: center;

  svg {
    fill: #000fff;
    cursor: pointer;
  }
`;

export const ContentTexts = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ContentSubtitle = styled.p`
  font-size: 16px;
  line-height: 1;
  color: #818181;
  margin: 10px 0 0;
`;

export const ContentComplement = styled.p`
  font-size: 14px;
  line-height: 1;
  color: #818181;
  margin: 0;
`;

export const ContentResult = styled.div<ContentResultProps>`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px;
  border: 1px solid ${(props) => (props?.success ? "#0ecb00" : "#e60000")};
  border-radius: 15px;
  margin: 15px 0;

  svg {
    font-size: 100px;
    fill: #000fff;
  }

  p {
    text-align: end;
    font-size: 14px;
    color: #000fff;
    margin: 0;
  }
`;

export const ContentCode = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;

  button {
    height: 32px;
    line-height: 32px;
  }
`;

export const ContentButton = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 25px;
`;

export const Button = styled(Link)`
  padding: 10px 10px;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  background-color: ${({ theme }) => theme.colors.blue};
  color: #fff;
  border-radius: 4px;

  &:hover {
    text-decoration: none;
    color: #fff;
  }

  & svg {
    margin-left: 5px;
    font-size: 16px;
  }
`;
